export default __webpack_public_path__ + "static/media/gallery-wip-plug-pin_01.ea5a4720.jpg";